import CurrentI18n from '@common/utils/CurrentI18n';
import { translations } from './formatDateToDays.i18n';
export var formatDateToDays = function (date) {
    var _a = CurrentI18n.getInstance().global, t = _a.t, locale = _a.locale;
    var lang = locale.value;
    var now = new Date();
    var msPerSec = 1000;
    var msPerMin = 60 * msPerSec;
    var msPerHour = 60 * msPerMin;
    var msPerDay = 24 * msPerHour;
    var diff = Date.now() - date.getTime();
    // 1) Мгновенно
    if (diff < msPerSec) {
        return t(translations[lang].just_now);
    }
    // 2) Секунды
    var seconds = Math.floor(diff / msPerSec);
    if (seconds < 60) {
        return "".concat(seconds).concat(t(translations[lang].seconds_ago));
    }
    // 3) Минуты
    var minutes = Math.floor(diff / msPerMin);
    if (minutes < 60) {
        return "".concat(minutes).concat(t(translations[lang].minutes_ago));
    }
    // 4) Сегодня / Вчера по календарю
    // начало сегодняшнего дня
    var startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
    // начало вчерашнего дня
    var startOfYesterday = startOfToday - msPerDay;
    var hhmm = function (d) {
        return "".concat(d.getHours().toString().padStart(2, '0'), ":") +
            "".concat(d.getMinutes().toString().padStart(2, '0'));
    };
    if (date.getTime() >= startOfToday) {
        // если событие произошло после начала сегодняшнего дня
        return "".concat(t(translations[lang].today), " ").concat(hhmm(date));
    }
    if (date.getTime() >= startOfYesterday) {
        // если событие — между началом вчерашнего дня и началом сегодняшнего
        return "".concat(t(translations[lang].yesterday), " ").concat(hhmm(date));
    }
    // 5) Всё остальное — полноценная дата dd.MM.YYYY HH:mm
    var dd = date.getDate().toString().padStart(2, '0');
    var MM = (date.getMonth() + 1).toString().padStart(2, '0');
    var YY = date.getFullYear().toString().slice(-2);
    var hh = date.getHours().toString().padStart(2, '0');
    var mm = date.getMinutes().toString().padStart(2, '0');
    return "".concat(dd, ".").concat(MM, ".").concat(YY, " ").concat(hh, ":").concat(mm);
};
